"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
require("./common");
require("./translation");
require("./search");
require("./category");
require("./premium");
require("./popup");
require("./common/form");
require("./auth");
require("./event");
require("./sidebar");
